import React from 'react';
import psap1Locales from '../../../../../assets/locales/psap1Locales';
import { miniGazelle } from '../../../../../helpers';

const psapRule = (data, locale) => {
    const { genericName } = data;
    const categories = ['professionaldisplays', 'prodisplays'];

    if (psap1Locales.includes(locale) && categories.includes(genericName)) {
        return (
            <div className="pt-1">
                {locale !== 'en_IL' ? miniGazelle.label('countryAvailabilityNote', true) : 'Country availability may vary. Please contact our sales representative for more information.'}
            </div>
        );
    }
    return null;
};

export default psapRule;